import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import RatingComponent from '@prisjakt/ui-rating';
import {
  CardMedia,
  Card as CardComponent,
  CardContent,
} from '@prisjakt/ui/card';
import { Row } from '@prisjakt/ui/list/variants';

export const Card = styled(CardComponent)`
  height: 100%;
`;

export const Content = styled(CardContent)`
  flex: 1 1 auto;
  text-align: initial;
  padding-top: 0;
  word-break: break-word;
`;

export const Footer = styled(CardContent)`
  padding-top: 0;
`;

export const AddToList = styled.div`
  position: absolute;
  top: ${layout.measurements.spacingNormal};
  right: ${layout.measurements.spacingNormal};
  display: flex;
  flex-direction: column;

  > *:not(:first-child) {
    margin-top: ${layout.measurements.spacingNormal};
  }
`;

export const PriceInfo = styled.div``;

export const Properties = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const Rating = styled(RatingComponent)`
  margin-bottom: ${layout.measurements.spacingSmall};
`;

export const CategoryRank = styled.div``;

export const Link = styled(Clickable)`
  color: ${p => p.theme.colors.maybeBlue700};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.colors.maybeBlue500};
    text-decoration: underline;
  }
`;

type MediaProps = {
  $size: string;
};

export const Media = styled(CardMedia)<MediaProps>`
  overflow: visible;
  height: ${p => p.$size};
  margin: ${layout.measurements.spacingNormal} 0;

  &::after {
    background-color: transparent;
  }
`;

export const DiffPercentageCore = styled.div`
  background: ${p => p.theme.colors.redio500};
  padding: 0.1rem 0.4rem;
  border-radius: 2px;

  ${media.mediumUp`
    top: ${layout.productCardPaddingLarge};
    left: ${layout.productCardPaddingLarge};
  `}
`;

export const DiffPercentage = styled(DiffPercentageCore)`
  position: absolute;
  top: ${layout.productCardPaddingSmall};
  left: ${layout.productCardPaddingSmall};
`;

export const PriceWrapper = styled(Row)`
  && {
    align-items: baseline;
    flex: 0 1 auto;
  }
`;

export const BrandLogo = styled.img`
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: ${layout.measurements.spacingNormal};
  max-height: 20px;
`;
